import React from "react";
import { BLOGS } from "../../constants/BlogConstant";
import { Link } from "react-router-dom";
import { getRecentBlogs } from "../../utils/blogUtils";

const RecentBlogs = () => {
  const recentPosts = getRecentBlogs(BLOGS);
  return (
    <div className="single-widgets widget_egns_recent_post">
      <div className="widget-title">
        <h4>Recent Blogs</h4>
      </div>
      <div className="recent-post-wraper">
        {recentPosts.map(({ id, title, cardImage, publishedDate }) => (
          <div className="widget-cnt" key={id}>
            <div className="wi">
              <Link to={`/blogs/${id}`}>
                <img src={cardImage} alt={title} />
              </Link>
            </div>
            <div className="wc">
              <h6>
                <Link to={`/blogs/${id}`}>{title}</Link>
              </h6>
              <Link to={`/blogs/${id}`}>{publishedDate}</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentBlogs;
